import { render, staticRenderFns } from "./KioskAttendeesView.vue?vue&type=template&id=4ebd0c35&"
import script from "./KioskAttendeesView.vue?vue&type=script&lang=js&"
export * from "./KioskAttendeesView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports